import { Injectable } from "@angular/core";
import { Actions, createEffect, ofType } from "@ngrx/effects";
import { Store } from "@ngrx/store";
import { CoreState, CustomerManagementSelector } from "@obg/ngx.core";
import { SignalrAction } from "@obg/ngx.real-time.signalr";
import { ignoreNil } from "@obg/rxjs";
import { map, switchMap, take } from "rxjs/operators";

import { RealTimeNotificationsAction } from "./real-time-notifications.action";
import { RealTimeNotificationsService } from "./real-time-notifications.service";

@Injectable()
export class RealTimeNotificationsEffect {
	customerTransmitconnectionSucess$ = createEffect(() =>
		this.actions$.pipe(
			ofType(SignalrAction.connectCustomerTransmitSuccess),
			switchMap(() =>
				this.store.select(CustomerManagementSelector.getCustomerId).pipe(
					ignoreNil(),
					take(1),
					map((customerId: string) => RealTimeNotificationsAction.connectionSuccess(customerId))
				)
			)
		)
	);

	getRealTimeUpdates$ = createEffect(() =>
		this.actions$.pipe(
			ofType(SignalrAction.customerTransmitChannelMessage),
			map(({ message }) => this.realTimeNotificationsService.processStreamMessages(message)),
			ignoreNil()
		)
	);

	subscribeToChannel$ = createEffect(() =>
		this.actions$.pipe(
			ofType(RealTimeNotificationsAction.subscribeToChannel),
			map(({ channel }) => SignalrAction.subscribeToCustomerTransmitChannel(channel))
		)
	);

	constructor(
		private actions$: Actions,
		private store: Store<CoreState>,
		private realTimeNotificationsService: RealTimeNotificationsService
	) {}
}
